import React, { useState, Fragment } from "react";
import { calcularTotal } from "../helpers";

//son los de app.js
const Formulario = (props) => {
  // paso las propiedades de formulario asignandolas a una variable
  const {
    plazo,
    guardarPlazo,
    guardarTotal,
    guardarCargando,
    nota,
    guardarNota,
    ponderacion,
    guardarPonderacion,
  } = props;

  //state local
  const [error, GuardarError] = useState(false);

  //Cuando el usuario hace submit
  const calcularNota = (e) => {
    e.preventDefault();

    //validar
    if (nota === 0 || ponderacion === "") {
      GuardarError(true);
      return;
    }

    //eliminar error previo
    GuardarError(false);


    //Habilitar Spinner
    guardarCargando(true);

    //setTimeout para realizar accion despues de un tiempo
    setTimeout(() => {
      //realizar cotizacion
      const total = calcularTotal(nota, ponderacion);

      //ya todo calculado se guarda el total
      guardarTotal(total);

      //Desahilitar spinner
      guardarCargando(false);
    }, 3000);

      

  };

  return (
    <Fragment>
      <form onSubmit={calcularNota}>
        <div className="row">
          <div className="five columns">
            <h6>Ponderado de Pruebas</h6>
            <input
              type="number"
              placeholder="Ejemplo: 6"    
              onChange={(e) => guardarNota(parseInt(e.target.value))}
    
            />
          </div>
          <div className="five columns">
            <h6>Ponderacion %</h6>
            <select
              onChange={(e) => guardarPonderacion(parseInt(e.target.value))}
            >
              <option value="">Ponderacion en %</option>
              <option value="5">5%</option>
              <option value="10">10%</option>
              <option value="15">15%</option>
              <option value="20">20%</option>
              <option value="25">25%</option>
              <option value="30">30%</option>
              <option value="35">35%</option>
              <option value="40">40%</option>
              <option value="45">45%</option>
              <option value="50">50%</option>
              <option value="55">55%</option>
              <option value="60">60%</option>
              <option value="65">65%</option>
              <option value="70">70%</option>
              <option value="75">75%</option>
              <option value="80">80%</option>
              <option value="85">85%</option>
              <option value="90">90%</option>
              <option value="95">95%</option>

            </select>
          </div>
          <div className="two columns">
            {plazo}
            <h6>Agregar</h6>
            <input
              type="button"
              className="button-primary"      
              value="Agregar Nota"   
              id="boton"
              onClick={(e) => guardarPlazo(parseInt(e.target.value))}
            />
          </div>
        </div>
        <br></br>
        <div className="row">
          <div>
            <input
              type="submit"
              value="Calcular"
              className="button-primary u-full-width"
              id="boton"
            />
          </div>
        </div>
      </form>
      {error ? (
        <p className="error"> Todos los campos son obligatorios</p>
      ) : null}
    </Fragment>
  );
};

export default Formulario;
